import React from "react";
import { FaPython, FaReact } from "react-icons/fa";
import { SiTailwindcss, SiDjango } from "react-icons/si";
import { Link } from "react-scroll";

const Services = () => {
  return (
    <div className="w-full bg-gray-800" id="skills">
      <div className="flex items-end justify-end  top-0 right-1 bottom-1 z-30  fixed lg:px-8 px-1 lg:py-24 md:py-8 py-4">
        <Link to="hero" smooth={true} duration={500} eaxct="true" spy={true}>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-10 w-10 animate-pulse bg-red-500 text-white rounded-full p-2 cursor-pointer"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M4.293 15.707a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414 0zm0-6a1 1 0 010-1.414l5-5a1 1 0 011.414 0l5 5a1 1 0 01-1.414 1.414L10 5.414 5.707 9.707a1 1 0 01-1.414 0z"
              clipRule="evenodd"
            />
          </svg>
        </Link>
      </div>
      <section className="max-w-4xl mx-auto px-4 py-16 lg:max-w-full lg:px-32 ">
        <div className="text-center pb-6">
          <h1 className="font-bold text-2xl md:text-3xl lg:text-4xl font-heading text-white">
            Tech I Use
          </h1>
        </div>
        <div className="grid grid-cols-1  md:grid-cols-2 lg:grid-cols-2 gap-8">
          <div className="w-full bg-gray-900 rounded-lg shadow-md p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out ">
            <div className="mb-8 text-red-400">
              <FaPython />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Python</p>
              <p className="text-base text-gray-400 font-normal ">
                I use this specifically for building a backend of project lay on
                my hands.
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out ">
            <div className="mb-8 text-red-400">
              <FaReact />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">React Js</p>
              <p className="text-base text-gray-400 font-normal">
                Facilitates on building a nicely UI which finaly I integrate
                with my backend application.
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out ">
            <div className="mb-8 text-red-400">
              <SiTailwindcss />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Tailwinds Css</p>
              <p className="text-base text-gray-400 font-normal">
                I use for styling my react UI and be more responsive for every
                devices.
              </p>
            </div>
          </div>
          <div className="w-full bg-gray-900 rounded-lg sahdow-lg p-12 flex flex-col justify-center items-center transition duration-500 ease-in-out">
            <div className="mb-8 text-red-400">
              <SiDjango />
            </div>
            <div className="text-center">
              <p className="text-xl text-white font-bold mb-2">Django</p>
              <p className="text-base text-gray-400 font-normal">
                I work with Django Restframework to create the RestFul API's of
                my project.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
